export default __webpack_public_path__ + "static/media/physicsIcon.52dd4a7d.svg";